// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1LUKq","disabled":"FileBtn_disabled__2sdDr","warn":"FileBtn_warn__3UHYv","fade":"FileBtn_fade__2aX_z"};